import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _targetingParamRulesv, _targetingsRulesValid;

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _times from 'lodash/times';
import _some from 'lodash/some';
import _reduce from 'lodash/reduce';
import _toLower from 'lodash/toLower';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import { findArrayItem, getArrayLength } from '.';
import { addDays, getMomentObject, getAbsoluteDifferenceAsDays, getToday } from '../../utils/dateUtils';
import { EMPTY_STRING, EMPTY_ARRAY, EMPTY_OBJECT } from '../../app.constants';
import { STOCK_TYPE, PAYMENT_TYPE, MAKES, TRADE_IN_OWNERSIP_TYPE, TRADE_INS, STATES, LENDERS, LICENSE_EXPIRATION_DATE_IN_DAYS, MODEL_YEAR, FUEL_TYPE, BODY_CLASS, TRADE_IN_VALUE, SITE, COLLECT_ONLY_WHEN_COLLECTFEE_IS_ON, DEAL_TYPE, MODEL_YEAR_DIFFERENCE_LESSER_THAN } from '../constants/constants';
import * as VehicleReader from '../readers/vehicle.reader';

function vehicleTypeFeeSupported(props) {
  var status = props.status,
      setupVehicleType = props.values,
      paramsRequired = props.paramsRequired;
  var vehicle = _get(paramsRequired, 'vehicle') || EMPTY_OBJECT;
  var currentVehicleType = VehicleReader.getVehicleType(vehicle);
  if (_isEmpty(setupVehicleType)) return status;
  return setupVehicleType.includes(currentVehicleType);
}

function paymentTypeforFeeSupported(props) {
  var status = props.status,
      paymentTypes = props.values,
      paramsRequired = props.paramsRequired;

  var columnPaymentType = _get(paramsRequired, 'columnPaymentType');

  if (_isEmpty(paymentTypes)) return status;
  return paymentTypes.includes(columnPaymentType);
}

export var getTradeInValue = function getTradeInValue() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "".concat(TRADE_IN_VALUE).concat(index + 1);
};

function tradeInFeeSupported(props) {
  var status = props.status,
      setupTradeIns = props.values,
      paramsRequired = props.paramsRequired,
      targetingParams = props.targetingParams;
  var currentTradeIns = paramsRequired.tradeIns;
  var tradeInOwnerShipAttributes = findArrayItem(targetingParams, 'attribute', TRADE_IN_OWNERSIP_TYPE) || EMPTY_OBJECT;
  var setupTradeInOwner = _get(tradeInOwnerShipAttributes, 'values') || EMPTY_ARRAY;

  var setupTradeInsEmpty = _isEmpty(setupTradeIns);

  var setupOwnershipEmpty = _isEmpty(setupTradeInOwner);

  if (setupTradeInsEmpty && setupOwnershipEmpty) return status;
  var dealTradeInCount = getArrayLength(currentTradeIns);

  var dealTradeInTypes = _times(dealTradeInCount, getTradeInValue);

  if (!setupTradeInsEmpty && setupOwnershipEmpty) {
    return _some(setupTradeIns, function (setupTradeIn) {
      return dealTradeInTypes.includes(setupTradeIn);
    });
  }

  if (!setupTradeInsEmpty && !setupOwnershipEmpty) {
    var filteredTradeIns = _reduce(dealTradeInTypes, function (tradeIns, tradeIn, index) {
      if (setupTradeIns.includes(tradeIn)) tradeIns.push(currentTradeIns[index]);
      return tradeIns;
    }, []);

    return _some(filteredTradeIns, function (tradeIn) {
      return setupTradeInOwner.includes(_get(tradeIn, 'ownerShipType'));
    });
  }

  return false;
}

function makeFeeSupported(props) {
  var status = props.status,
      setupMakes = props.values,
      paramsRequired = props.paramsRequired;
  var vehicle = _get(paramsRequired, 'vehicle') || EMPTY_OBJECT;

  var _VehicleReader$getYMM = VehicleReader.getYMM(vehicle),
      currentMake = _VehicleReader$getYMM.make;

  if (_isEmpty(setupMakes)) return status;

  var makeInLowerCase = _toLower(currentMake);

  var setupMakesInLowerCase = _map(setupMakes, _toLower);

  return setupMakesInLowerCase.includes(makeInLowerCase);
}

function stateFeeSupported(props) {
  var status = props.status,
      setupStates = props.values,
      paramsRequired = props.paramsRequired;

  var currentState = _get(paramsRequired, 'customerState');

  if (_isEmpty(setupStates)) return status;
  return setupStates.includes(currentState);
}

function lenderFeeSupported(props) {
  var status = props.status,
      allowedLenders = props.values,
      paramsRequired = props.paramsRequired;

  var selectedLenderId = _get(paramsRequired, 'lenderId');

  if (_isEmpty(allowedLenders)) return status;
  return allowedLenders.includes(selectedLenderId);
}

function licenceExpirationDateInDaysFeeSupported(props) {
  var values = props.values,
      paramsRequired = props.paramsRequired;
  var isExpired = false;
  var days = _get(values, 0) || 0;
  var startDate = addDays(days);
  var endDateTimeStamp = Number(_get(paramsRequired, ['vehicle', 'licensePlateExpirationDate']) || 0);

  if (endDateTimeStamp) {
    var endDate = getMomentObject(endDateTimeStamp);
    isExpired = !((getAbsoluteDifferenceAsDays(startDate, endDate) || 0).toFixed() > 0);
  }

  return isExpired;
}

function modelYearDiffGreaterThanSupported(props) {
  var values = props.values,
      paramsRequired = props.paramsRequired;
  var modelYearDiff = Number(_get(values, 0) || 0);
  var mfgYear = Number(_get(paramsRequired, ['vehicle', 'year']));
  var currYear = Number(getToday().format('YYYY'));
  var isOwnerNeedToPayFees = mfgYear && currYear - mfgYear > modelYearDiff;
  return isOwnerNeedToPayFees;
}

function modelYearDiffLesserThanSupported(props) {
  var values = props.values,
      paramsRequired = props.paramsRequired;
  var modelYearDiff = Number(_get(values, 0) || 0);
  var mfgYear = Number(_get(paramsRequired, ['vehicle', 'year']));
  var currYear = Number(getToday().format('YYYY'));
  var isOwnerNeedToPayFees = mfgYear && currYear - mfgYear < modelYearDiff;
  return isOwnerNeedToPayFees;
}

function fuelTypeSupported(props) {
  var values = props.values,
      paramsRequired = props.paramsRequired;
  var fuelType = _get(paramsRequired, ['vehicle', 'trimDetails', 'fuelType']) || EMPTY_STRING;
  var isFuelSupports = (values || EMPTY_ARRAY).includes(fuelType);
  return isFuelSupports;
}

function bodyClassFeeSupported(props) {
  var values = props.values,
      paramsRequired = props.paramsRequired;
  var bodyClass = _get(paramsRequired, ['vehicle', 'trimDetails', 'bodyClass']) || EMPTY_STRING;
  var isBodyClassSelected = (values || EMPTY_ARRAY).includes(bodyClass);
  return isBodyClassSelected;
}

function isSiteSupported(props) {
  var status = props.status,
      siteIds = props.values,
      paramsRequired = props.paramsRequired;

  var currentSIteId = _get(paramsRequired, 'siteId');

  if (_isEmpty(siteIds)) return status;
  return siteIds.includes(currentSIteId);
}

function collectFeeChecker(props) {
  var status = props.status,
      values = props.values,
      paramsRequired = props.paramsRequired;

  var collectFee = _get(paramsRequired, 'collectFee');

  if (_isEmpty(values)) return status;
  if (_includes(values, 'false')) return true;
  if (_includes(values, 'true') && collectFee) return true;
  return false;
}

function isDealTypeSupported(props) {
  var status = props.status,
      values = props.values,
      paramsRequired = props.paramsRequired;

  var dealType = _get(paramsRequired, 'dealType');

  if (_isEmpty(values)) return status;
  return _includes(values, dealType);
}

export var targetingParamRulesvalidatorFunction = (_targetingParamRulesv = {}, _defineProperty(_targetingParamRulesv, STOCK_TYPE, vehicleTypeFeeSupported), _defineProperty(_targetingParamRulesv, PAYMENT_TYPE, paymentTypeforFeeSupported), _defineProperty(_targetingParamRulesv, TRADE_INS, tradeInFeeSupported), _defineProperty(_targetingParamRulesv, MAKES, makeFeeSupported), _defineProperty(_targetingParamRulesv, STATES, stateFeeSupported), _defineProperty(_targetingParamRulesv, LENDERS, lenderFeeSupported), _defineProperty(_targetingParamRulesv, TRADE_IN_OWNERSIP_TYPE, function (currentStatus) {
  return currentStatus;
}), _defineProperty(_targetingParamRulesv, LICENSE_EXPIRATION_DATE_IN_DAYS, licenceExpirationDateInDaysFeeSupported), _defineProperty(_targetingParamRulesv, MODEL_YEAR, modelYearDiffGreaterThanSupported), _defineProperty(_targetingParamRulesv, MODEL_YEAR_DIFFERENCE_LESSER_THAN, modelYearDiffLesserThanSupported), _defineProperty(_targetingParamRulesv, FUEL_TYPE, fuelTypeSupported), _defineProperty(_targetingParamRulesv, BODY_CLASS, bodyClassFeeSupported), _defineProperty(_targetingParamRulesv, SITE, isSiteSupported), _defineProperty(_targetingParamRulesv, COLLECT_ONLY_WHEN_COLLECTFEE_IS_ON, collectFeeChecker), _defineProperty(_targetingParamRulesv, DEAL_TYPE, isDealTypeSupported), _targetingParamRulesv);
export var targetingsRulesValidatorParams = (_targetingsRulesValid = {}, _defineProperty(_targetingsRulesValid, STOCK_TYPE, ['vehicle']), _defineProperty(_targetingsRulesValid, PAYMENT_TYPE, ['columnPaymentType']), _defineProperty(_targetingsRulesValid, TRADE_INS, ['tradeIns']), _defineProperty(_targetingsRulesValid, MAKES, ['vehicle']), _defineProperty(_targetingsRulesValid, STATES, ['customerState']), _defineProperty(_targetingsRulesValid, LENDERS, ['lenderId']), _defineProperty(_targetingsRulesValid, LICENSE_EXPIRATION_DATE_IN_DAYS, ['vehicle']), _defineProperty(_targetingsRulesValid, MODEL_YEAR, ['vehicle']), _defineProperty(_targetingsRulesValid, FUEL_TYPE, ['vehicle']), _defineProperty(_targetingsRulesValid, BODY_CLASS, ['vehicle']), _defineProperty(_targetingsRulesValid, SITE, ['siteId']), _defineProperty(_targetingsRulesValid, COLLECT_ONLY_WHEN_COLLECTFEE_IS_ON, ['collectFee']), _defineProperty(_targetingsRulesValid, DEAL_TYPE, ['dealType']), _defineProperty(_targetingsRulesValid, MODEL_YEAR_DIFFERENCE_LESSER_THAN, ['vehicle']), _targetingsRulesValid);